// No-op in production builds. Use for editor/canvas debug logging that
// should never surface in end-user consoles. CLAUDE.md forbids raw
// `console.log` in committed code; this is the canonical replacement.
export const studioDebug: (...args: unknown[]) => void = import.meta.env.DEV
  ? (...args) => { console.log(...args); }
  : () => {};
